<template>
    <div>
      <div class="crumbs">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>
            <i class="el-icon-lx-calendar"></i> 日志管理
          </el-breadcrumb-item>
          <el-breadcrumb-item>日志查询</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
      <div class="container">
        <div class="handle-box">
          <el-form ref="searchform" :model="searchform" label-width="80px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="日期" prop="time">
                    <el-date-picker
                      v-model="searchform.time"
                      type="date"
                      placeholder="选择日期">
                    </el-date-picker>
                </el-form-item>
              </el-col>   
              <el-col :span="6">
                <el-form-item label="工单" prop="orderno">
                  <el-input v-model="searchform.orderno"></el-input>
                </el-form-item>
              </el-col>  
              <el-col :span="6">
                <el-form-item label="线体" prop="line">
                  <el-input v-model="searchform.line"></el-input>
                </el-form-item>
              </el-col> 
            </el-row>
            <el-row>
              <el-col :span="6">
                <el-form-item label="错误代码" prop="errcode">
                  <el-input v-model="searchform.errcode"></el-input>
                </el-form-item>
              </el-col> 
              <el-col :span="6">
                <el-form-item label="开始时间" prop="starttime">
                  <el-time-picker
    is-range
    v-model="arrtime"
    range-separator="至"
    start-placeholder="开始时间"
    end-placeholder="结束时间"
    placeholder="选择时间范围"
    value-format="HH:mm" format="HH:mm"
    >
  </el-time-picker>
                </el-form-item>
              </el-col> 
              <!-- <el-col :span="6">
                <el-form-item label="结束时间" prop="endtime">
                  <el-time-picker v-model="searchform.endtime" :picker-options="{selectableRange: '18:30:00 - 20:30:00'}" placeholder="任意时间点">
                </el-form-item>
              </el-col>  -->
            </el-row>
                        <el-row>
              <el-col :span="16" :offset="1"> 
                 <el-button @click="resetForm('searchform')">重置</el-button>
                <el-button type="primary" icon="el-icon-search" @click="search" >搜索</el-button>
                <el-button
                v-permission="['customerquery_export']"
                  :loading="downloadLoading"
                  type="primary"
                  icon="document"
                  @click="handleDownload"
                >导出Excel</el-button>
              </el-col>
              </el-row> 
          </el-form>
        </div>
  <br>
        <el-row type="flex" class="row-bg">
          <el-col :span="24" class="border">
            <h4>消费者扫码查询</h4>
            <el-divider></el-divider>
            <el-table
              border
              v-loading="listLoading"
              element-loading-text="拼命加载中"
              :data="tableData"
              style="width:100%;"
              id="parent"
            >
              <el-table-column prop="orderNo" label="工单" width="120" ></el-table-column>
              <el-table-column prop="batchNo" label="批次" min-width="120" ></el-table-column>
              <el-table-column prop="product" label="产品" width="100" ></el-table-column>
              <el-table-column prop="workshop" label="车间" min-width="100" ></el-table-column>
              <el-table-column prop="workline" label="线体" min-width="80" ></el-table-column>
              <el-table-column prop="workstation" label="工位" min-width="80" ></el-table-column>
              <el-table-column prop="code" label="错误代码" min-width="120" ></el-table-column>
              <el-table-column prop="codeName" label="日志标识" min-width="120" ></el-table-column>
              <el-table-column prop="recordTime" label="记录时间" min-width="120" ></el-table-column>
              <el-table-column prop="describe" label="描述" min-width="120" ></el-table-column>
            </el-table>
            <br />
            <el-pagination
              background
              @current-change="currentchange"
              @size-change="pagesize"
              :current-page.sync="currentPage"
              :page-sizes="[10,20,30,50]"
              layout="total,prev, pager, next,jumper,sizes"
              :total="total_count"
            ></el-pagination>
          </el-col>
        </el-row>
      </div>
    </div>
  </template>
  <script>
  import { getlogslist } from "@/api/logs";
  export default {
    mounted() {
      //请求部门列表数据并且便利到表格
      this.search();
    },
    data() {
      return {
        //基础数据
        listLoading: false,
        depart_uuid: [],
        tableData: [],
        brandlist:[],     
        //产品列表下拉
        productloading: false,
        show: false,
        productlist: [], 
        //分页数据
        pagesizes: "",
        total_count: 1,
        currentPage: 1,
         //导出表格变量
        tableDataDownload: [],
        downloadLoading: false,
        filename: "",
        autoWidth: true,
        bookType: "xlsx",
        arrtime:["00:00", "23:59"],
        //搜索表单数据
        searchform: {
          time:new Date().toDateString(),
          orderno:"",
          line:"",
          errcode:"",
          starttime:"",
          endtime:"",
          pageIndex:1,
          pageSize:10
        }
      };
    },
    methods: {
      //请求表格数据
      Tabledata(obj) {
        this.listLoading = true;
        getlogslist(obj).then(response => {
          this.tableData = response.data.data;
          this.packdate(this.tableData)
          this.total_count = response.data.totalCount;
          this.currentPage = response.data.currPage;
          this.listLoading = false;
          console.log(this.tableData)
        });
      },
      packdate(obj){
        if(obj)
        {
          for (let i = 0; i < obj.length; i++) {
           obj[i].recordTime =  obj[i].recordTime.replace("T"," ");
           obj[i].createTime =  obj[i].createTime.replace("T"," ");
           
          }
        }
        
      },
      //搜索事件
      search() {
        if(this.arrtime.length>0)
        {
          this.searchform.starttime=this.arrtime[0];
          this.searchform.endtime=this.arrtime[1];
        }
          this.Tabledata(this.searchform);
      },
      //重置按钮
      resetForm(formName) {
        this.$refs[formName].resetFields();
        // this.searchform.starttime=  [new Date(2016, 9, 10, 8, 40), new Date(2016, 9, 10, 9, 40)];
      },
      //分页跳转事件
      currentchange(currPage) {
        this.searchform.pageIndex = currPage
         this.search();
      },
      //分页每页显示条数事件
      pagesize(pageSize) {
        this.searchform.pageSize = pageSize
        this.search()
      },
      //导出表格事件
      handleDownload() {
        this.downloadLoading = true;
        const obj = {
          PageIndex: 1,
          pageSize: this.total_count,
          time:this.searchform.time,
        };
        getlogslist(obj).then(response => {
          this.packdate(response.data.data);
          this.tableDataDownload = response.data.data;
  
          console.log(this.tableDataDownload);
          import("@/vendor/Export2Excel").then(excel => {
            const tHeader = [
            "工单",
            "批次",
            "产品",
            "车间",
            "线体",
            "工位",
            "错误代码",
            "日志标识",
            "记录时间",
            "描述",
            ];
            const filterVal = [
            "orderNo",    
            "batchNo",    
            "product",    
            "workshop",   
            "workline",   
            "workstation",
            "code",       
            "codeName",   
            "recordTime", 
            "describe",   
  
            ];
            const list = this.tableDataDownload;
            const data = this.formatJson(filterVal, list);
            excel.export_json_to_excel({
              header: tHeader,
              data,
              filename: this.filename,
              autoWidth: this.autoWidth,
              bookType: this.bookType
            });
            this.downloadLoading = false;
          });
        }); // hear
      },
      formatJson(filterVal, jsonData) {
        return jsonData.map(v =>
          filterVal.map(j => {
            if (j === "timestamp") {
              return parseTime(v[j]);
            } else {
              return v[j];
            }
          })
        );
      },
      //跳转页面
      tiaozhuan() {
        this.$router.push({
          path: "/staffedit"
        });
      }
    }
  };
  </script>
  <style scoped>
  .el-divider--horizontal {
    display: block;
    height: 1px;
    width: 100%;
    margin: 10px 0;
  }
  .border {
    padding: 10px 10px;
    border-radius: 3px;
    border: 1px solid #e6ebf5;
    background-color: #fff;
    overflow: hidden;
    color: #303133;
    -webkit-transition: 0.3s;
    transition: 0.3s;
  }
  .handle-box {
    margin-bottom: 0px;
  }
  .handle-input {
    width: 160px;
    display: inline-block;
  }
  .del-dialog-cnt {
    font-size: 16px;
    text-align: center;
  }
  .mr10 {
    margin-right: 10px;
  }
  #parent {
    text-align: center;
  }
  </style>